import { consentForCareProps } from '../../types/Consent/consentForCare';

export const ConsentSubSectionText = (props: consentForCareProps) => {
  return <p className="my-1 ml-2 text-sm font-semibold">{props.text}</p>;
};
